import singleSpaAngularJS from "single-spa-angularjs";
import {loadByOrder} from "@/spa/funcs.js";
import {getParcel} from "../parcelGetter.js";

const files = [
	["/callcenter/scripts/vendor.js"],
	[
		"/pbx2/scripts/vendor.js",
		"/pbx2/templateCache/components/templates.js",
		"/pbx2/templateCache/local/templates.js"
	],
	[
		"/configFile.js?v=2",
		"/pbx2/scripts/app.js"
	]
];

const spaconf = {
	name: "pbx",
	async load() {
		return loadByOrder(files);
	},
	getAppConfig() {
		function elementGetter() {
			let container = document.getElementById("spaContainer");
			return container;
		}

		let spa = singleSpaAngularJS({
			angular: window.angular,
			domElementGetter: elementGetter,
			mainAngularModule: "new-web",
			uiRouter: true,
			preserveGlobal: true,
			template: `
<div ng-controller="MainController as main" ng-model-options="{allowInvalid: true}"
    when-online="verifySessionIfExists()">
	<div ui-view="" ng-cloak="">
        <div class="screen-height" style="position: relative;">
            <div class="text-center"
                style="width: 380px; height: 24px; position: absolute; margin: auto; top: 0; left: 0; right: 0; bottom: 0;">
                <div class="sk-spinner sk-spinner-three-bounce">
                    <div class="sk-bounce1"></div>
                    <div class="sk-bounce2"></div>
                    <div class="sk-bounce3"></div>
                </div>
            </div>
        </div>
    </div>
			<link rel="stylesheet" ng-href="/pbx2/styles/vendor.css" />
			<link rel="stylesheet" ng-href="/pbx2/styles/app.css" />
			<link rel="stylesheet" href="https://tkrotoff.github.io/famfamfam_flags/famfamfam-flags.css" />
</div>
			`
		});

		spa.mount = [spa.mount, function(context) {
			let aelement = angular.element(elementGetter().children[0]);
			let injector = aelement.injector();
			let myConfigService = injector.get("myConfig");
			myConfigService.doParcel = function(name, element) {
				console.info("DO PARCEL " + name);
				return getParcel(context.mountParcel, name, element, {angularInjector: injector});
			};
			console.info("custom mount hook", {a: this, args: arguments}, injector);
			return Promise.resolve();
		}];

		return spa;
	}
};

export default spaconf;
